<template>
    <request-balance
        :on-create="createRequest"
        :on-search-companies="searchCompaniesByName"
        :on-fetch-company-details="handleFetchCompany"
        :company="company"
        :total="total"
    />
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import RequestBalance from './RequestBalance.vue';
    import { fetchCompanyInfo } from '../../../services/api/request';

    export default {
        name: 'request-balance-container',
        components: {
            RequestBalance
        },
        data() {
            return {
                company: {}
            }
        },
        computed: {
            ...mapGetters('request', [
                'selectedProducts',
                'total',
            ]),
        },
        methods: {
            ...mapActions('request', ['createRequest']),
            ...mapActions('requestTableInns', ['searchCompaniesByName']),
            ...mapActions(['error']),

            handleFetchCompany(inn) {
                this.company = {};
                return fetchCompanyInfo(inn)
                    .then((res) => {
                        this.company = res.data;
                        return res;
                    })
                    .catch((res) => {
                        this.error(res);
                        throw res;
                    });
            }
        },
        created() {
            if (!this.selectedProducts.length) {
                this.$router.push({ name: 'requestProducts' });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// RequestBalanceContainer.vue?4ee8815a